import LanguageContextProvider from 'components/context/LanguageContext';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { HomeScreen, OrderScreen } from './screens';

const App = () => {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <HomeScreen />,
    },
    {
      path: '/order',
      element: <OrderScreen />,
    },
  ]);

  return (
    <LanguageContextProvider>
      <RouterProvider router={router} />
    </LanguageContextProvider>
  );
};
// this is a test
export default App;
